import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getPropertyDetail } from "reduxStore/action/propertyActions";
import strings from "translate/language";
import { handleDetailResponse, seo } from "utils/utils";
import ImageRender from "component/common/ImageRender";
import moment from "moment";
import VideoModel from "../../component/common/videoModel";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";
import PdfViewer from "component/common/pdfViewer";

const ViewProperty = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { property_id = "" } = params || {};
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const dispatch = useDispatch();
  const [viewDetails, setViewDetails] = useState({});
  const [videoDetails, setVideoDetails] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfView, setIsPdfView] = useState(false);
  const getPropertyDetailSelector =
    useSelector((state) => state.propertyData) || [];

  const handleNext = () => {
    navigatpage("/viewnextproperty/" + property_id);
  };

  useEffect(() => {
    if (getPropertyDetailSelector.response) {
      const { response } = getPropertyDetailSelector;
      if (response?.status === 200) {
        setViewDetails(handleDetailResponse(response?.data));
      } else {
        setViewDetails({});
      }
    }
  }, [getPropertyDetailSelector]);

  useLayoutEffect(() => {
    dispatch(getPropertyDetail({ property_id: property_id }));
  }, []);
  useEffect(() => {
    seo({
      title: "Property Details",
      metaDescription: "View property details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    isPdfView ?
      <PdfViewer pdfUrl={pdfUrl} backButton={() => {
        setIsPdfView(false)
        setPdfUrl(null)
      }} />
      :
      <div className="page-body">
        <VideoModel data={videoDetails} />
        <Breadcrumb
          title={strings.propertyDetails}
          url={"/property"}
          parentListing={strings.propertyListing}
          titleactive={strings.viewPropertyDetails}
          isBackBtn={true}
        />
        <div className="container-fluid">
          <div className="row ">
            <div className="col-sm-12 ">
              <div className="card">
                <div className="card-header">
                  <h5>{strings.propertyDetails}</h5>
                </div>
                <form className="form theme-form">
                  <div className="card-body">
                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.totalFlat} :{" "}
                        </label>
                      </div>
                      <div className=" col-md-1 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.total_invantry || 0}
                        </label>
                      </div>
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.soldOut} :
                        </label>
                      </div>
                      <div className=" col-md-1 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.sold_out || 0}
                        </label>
                      </div>
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.remaining} :
                        </label>
                      </div>
                      <div className=" col-md-1 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.total_remaining || strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />

                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.status} :
                        </label>
                      </div>

                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.status
                            ? "Active"
                            : "Deactive" || strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />

                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.propertyName} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.property_title || strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />

                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.noOfVisitor} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.total_visitor || 0}
                        </label>
                      </div>
                    </div>
                    <hr />

                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.noOfSiteVisit} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.site_visit || 0}
                        </label>
                      </div>
                    </div>
                    <hr />

                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.closeVisit} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center mt">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.close_visit || 0}
                        </label>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.city} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.city || strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.locality} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.location || strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.locationArea} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.area || strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.type} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {(viewDetails?.property_type_data &&
                            viewDetails?.property_type_title) ||
                            strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.crmPersonEmail} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.crm_person_email || strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.jqProjectID} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.jw_project_id || strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.createdDate} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {moment(viewDetails?.createdDate).format(
                            "DD-MM-yyyy hh:mm a"
                          ) || strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />

                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.startDate} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {moment(viewDetails?.start_date).format("DD-MM-yyyy") ||
                            strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />

                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htlmFor="exampleInputMobileNo">
                          {strings.endDate} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htlmFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {moment(viewDetails?.end_date).format("DD-MM-yyyy") ||
                            strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.configuration} :
                        </label>
                      </div>
                      <div className=" col-md-9 align-items-center">
                        {viewDetails?.configuration_area &&
                          viewDetails?.configuration_area.length > 0
                          ? viewDetails?.configuration_area?.map(
                            (item, index) => (
                              <div>
                                <label
                                  for="exampleInputMobileNo"
                                  className="boldText"
                                  key={index}
                                >
                                  {item.configuration_title} {"-"} Carpet Area {item.area} sq.ft
                                  {" ("}
                                  {"  "}Min : {item.min_rate}
                                  {item.min_rate_type}
                                  {" - "} Max : {item.max_rate}
                                  {item.max_rate_type}
                                  {", "} inventry : {item.inventry}
                                  {", "} sold : {item.sold_out}
                                  {", "} Remaining : {item.remaining}
                                  {")"}
                                </label>
                                <hr />
                              </div>
                            )
                          )
                          : strings.notavailable}
                      </div>
                    </div>
                    <hr />

                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.amenity} :
                        </label>
                      </div>

                      <div className="col-md-7 align-items-center">
                        {viewDetails?.amenity &&
                          viewDetails?.amenity.length > 0 ? (
                          <div>
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {viewDetails?.amenity
                                ?.map((item) => item?.title)
                                .join(", ")}
                            </label>
                            {/* <hr /> */}
                          </div>
                        ) : (
                          strings.notavailable
                        )}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-md-3 align-items-center">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.content} :
                        </label>
                      </div>
                      {viewDetails?.property_document &&
                        viewDetails?.property_document.length > 0 ? (
                        <>
                          {viewDetails?.property_document.filter(
                            (item) => item.document_type === "image"
                          ).length > 0 ? (
                            <div className="col-md-7">
                              <label
                                htmlFor="exampleInputMobileNo"
                                className="boldText"
                              >
                                {strings.images}
                              </label>
                              <div className="row">
                                {viewDetails?.property_document
                                  .filter(
                                    (item) => item.document_type === "image"
                                  )
                                  .map(
                                    (item, index) =>
                                      index < 3 && (
                                        <ImageRender
                                          key={index}
                                          baseUrl={viewDetails?.base_url}
                                          imageUrl={item.document}
                                          thumbnailUrl={item.document}
                                        />
                                      )
                                  )}
                                {viewDetails?.property_document.filter(
                                  ({ document_type }) => document_type === "image"
                                ).length > 3 ? (
                                  <div className="col-md-3">
                                    <i
                                      className="fa fa-arrow-circle-o-right right-icon pt-5"
                                      aria-hidden="true"
                                      onClick={() =>
                                        navigatpage(
                                          "/viewpropertynext/image/" + property_id
                                        )
                                      }
                                    ></i>
                                  </div>
                                ) : null}
                              </div>

                              <hr />
                            </div>
                          ) : (
                            <div className="col-md-7 align-items-center"></div>
                          )}
                          <div className="col-md-3 align-items-center"></div>
                          {viewDetails?.property_document.filter(
                            (item) => item.document_type === "video"
                          ).length > 0 ? (
                            <div className="col-md-7 align-items-center">
                              <label
                                htmlFor="exampleInputMobileNo"
                                className="boldText"
                              >
                                {strings.videos}
                              </label>
                              <div className="row">
                                {viewDetails?.property_document
                                  .filter(
                                    (item) => item.document_type === "video"
                                  )
                                  .map(
                                    (item, i) =>
                                      i < 3 && (
                                        <div key={i} className="col-md-3">
                                          <img
                                            src={
                                              viewDetails.base_url +
                                              item.video_thumbnail
                                            }
                                            className="img-thumbnail"
                                            style={{ position: "relative" }}
                                          />
                                          <i
                                            className="fa fa-play theme-fa-icon"
                                            style={{
                                              position: "absolute",
                                              right: " 59px",
                                              top: "22px",
                                              cursor: "pointer",
                                              color: "#fff",
                                            }}
                                            data-toggle="modal"
                                            data-original-title="test"
                                            data-target="#exampleModal"
                                            onClick={() => {
                                              item.base_url =
                                                viewDetails.base_url;
                                              setVideoDetails(item);
                                            }}
                                          ></i>
                                        </div>
                                      )
                                  ) || strings.notavailable}
                                {viewDetails?.property_document.filter(
                                  ({ document_type }) => document_type === "video"
                                ).length > 3 ? (
                                  <div className="col-md-3">
                                    <i
                                      className="fa fa-arrow-circle-o-right right-icon pt-3"
                                      aria-hidden="true"
                                      onClick={() =>
                                        navigatpage(
                                          "/viewpropertynext/video/" + property_id
                                        )
                                      }
                                    ></i>
                                  </div>
                                ) : null}
                              </div>
                              <hr />
                            </div>
                          ) : (
                            <div className="col-md-7 align-items-center"></div>
                          )}
                          <div className="col-md-3 align-items-center"></div>
                          {viewDetails?.property_document.filter(
                            (item) => item.document_type === "document"
                          ).length > 0 ? (
                            <div className="col-md-7 align-items-center mt-2">
                              <label
                                htmlFor="exampleInputMobileNo"
                                className="boldText"
                              >
                                {strings.catalogue}
                              </label>

                              <div className="row">
                                {(viewDetails?.property_document &&
                                  viewDetails?.property_document
                                    .filter(
                                      (item) => item.document_type === "document"
                                    )
                                    .map(
                                      (item, index) =>
                                        index < 3 && (
                                          <div key={index} className="col-md-2">
                                            <a
                                              // href={
                                              //   viewDetails.base_url +
                                              //   item.document
                                              // }
                                              // target={"_blank"}
                                              onClick={() => {
                                                setPdfUrl(viewDetails.base_url + item.document)
                                                setIsPdfView(true)
                                              }}
                                            >
                                              <img
                                                src="/assets/images/documentIcon.png"
                                                className="img-fluid view_pro"
                                                alt={item.document}
                                              />
                                            </a>
                                          </div>
                                        )
                                    )) ||
                                  strings.notavailable}
                                {viewDetails?.property_document.filter(
                                  ({ document_type }) =>
                                    document_type === "document"
                                ).length > 3 ? (
                                  <div className="col-md-3">
                                    <i
                                      className="fa fa-arrow-circle-o-right right-icon pt-3"
                                      aria-hidden="true"
                                      onClick={() =>
                                        navigatpage(
                                          "/viewpropertynext/document/" +
                                          property_id
                                        )
                                      }
                                    ></i>
                                  </div>
                                ) : null}
                              </div>
                              <hr />
                            </div>
                          ) : (
                            <div className="col-md-7 align-items-center"></div>
                          )}
                        </>
                      ) : (
                        <div className="col-md-7 align-items-center">
                          {strings.notavailable}
                        </div>
                      )}
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-md-3 align-items-center">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.pickupAllowed} :
                        </label>
                      </div>
                      <div className=" col-md-7 align-items-center">
                        <label
                          htmlFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewDetails?.pickup || strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />

                    <div className="row">
                      <div className=" col-md-3 align-items-center">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.allocated}
                        </label>
                      </div>
                      <div className="col-md-8 align-items-center">
                        {viewDetails?.property_allocateds &&
                          viewDetails?.property_allocateds.length > 0
                          ? viewDetails?.property_allocateds?.map(
                            (item, index) => (
                              <div key={index} className="">
                                <div className="row col-md-12">
                                  <label
                                    htmlFor="exampleInputMobileNo"
                                    className="boldText"
                                  >
                                    {item?.role_title}&nbsp;{" : "}&nbsp;
                                  </label>
                                  <div className="row pl-1">
                                    <div className="col-md-12 boldText">
                                      {item?.users
                                        ?.map((i) => i?.user_name)
                                        .join(", ")}
                                    </div>
                                  </div>
                                </div>
                                <hr />
                              </div>
                            )
                          )
                          : strings.notavailable}
                      </div>
                      <div className="col-md-12 d-flex justify-content-end">
                        <div className="card-footer">
                          <Button
                            className="btn btn-color"
                            onClick={() => handleNext()}
                            label={strings.next}
                          ></Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
export default ViewProperty;
